module.exports = __webpack_public_path__ + "static/img/qincai.9d082c15.png";